export default __webpack_public_path__ + "static/media/Uncle_Otis.4c8b8cb5.jpg";